import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { UsuarioService } from "src/app/shared/services/usuario.service";

export const possuiPerfilGestorGuard: CanActivateFn = (route, state) => {
  const usuarioService = inject(UsuarioService);
  return usuarioService.possuiPerfil("GSCLASSIF") ||
    usuarioService.possuiTodasTransacoes("CLSIMPOTAB")
    ? true
    : false;
};
